module.exports = __webpack_public_path__ + "img/mobile/Background-bonus/background_bonus_portrait@2x.jpg?0.0.53";